import {shoppingCartItemComponentView} from './shopping-cart-item_component.view';
import {IdealShoppingCartVariant} from '../../interfaces/shopping-cart.interface';
import {ShoppingCartItems} from '../shopping-cart-items';
import {Metrics} from '../../metrics';
import {MATOMO_EVENT_NAMES} from '../../metric-events';
import {AppState} from '../../shared/app.state';
import {CurrencyService} from '../../api/services/currency.service';
import {UrlUtils} from '../../api/urls';
import {IdealCartService} from '../../api/services/ideal-cart.service';
import {ShoppingCartItemBaseComponent} from './shopping-cart-item_base_component';

export class IdealShoppingCartItemComponent extends ShoppingCartItemBaseComponent {
  private overallQuantity: number;
  private productName: string;

  constructor(
    protected shoppingCartItems: ShoppingCartItems,
    protected product: IdealShoppingCartVariant,
    protected currencyService: CurrencyService,
    protected shoppingCartService: IdealCartService
  ) {
    super(shoppingCartItems, product, currencyService, shoppingCartService);
  }

  renderItem() {
    this.mainContainer.classList.add('app-shopping-cart-item');
    if (this.product.quantity <= 0) {
      this.product.quantity = 0;
      this.mainContainer.classList.add('out-of-stock');
    }
    const shoppingCartItemContainer = document.createElement('div');
    this.mainContainer.append(shoppingCartItemContainer);
    this.productName = UrlUtils.slugify(this.product.title);
    shoppingCartItemContainer.outerHTML = shoppingCartItemComponentView(this.product, this.getProductPrice());
    this.updateDisableState();
    return this.mainContainer;
  }

  changeQuantity(el: HTMLElement) {
    const operation = el.classList.contains('app-shopping-cart-item-increase') ? 'increase' : 'decrease';
    const currQuantity = this.product.quantity;
    switch (operation) {
      case 'increase': {
        if (this.overallQuantity + 1 > this.product?.quantity_available) {
          return;
        }
        this.product.quantity += 1;
        Metrics.storeTheEvent(
          AppState.planogramName,
          'click',
          MATOMO_EVENT_NAMES.CLICK_SHOPPING_CART_OVERLAY_INCREASE_ITEM_QUANTITY(
            this.product?.sku,
            this.productName
          )
        );
        this.shoppingCartItems.updateShoppingCart(this.product);
        break;
      }
      case 'decrease': {
        if (currQuantity - 1 >= 1) {
          this.product.quantity -= 1;
          Metrics.storeTheEvent(
            AppState.planogramName,
            'click',
            MATOMO_EVENT_NAMES.CLICK_SHOPPING_CART_OVERLAY_DECREASE_ITEM_QUANTITY(
              this.product?.sku,
              this.productName
            )
          );
          this.shoppingCartItems.updateShoppingCart(this.product);
        }
        break;
      }
    }
    this.updateDisableState();
  }

  updateDisableState() {
    const increaseButton = this.mainContainer.querySelector<HTMLElement>('.app-shopping-cart-item-increase');
    const decreaseButton = this.mainContainer.querySelector<HTMLElement>('.app-shopping-cart-item-decrease');
    this.countOverallQuantity();

    if (increaseButton) {
      this.overallQuantity >= this.product.quantity_available
        ? increaseButton.classList.add('disabled')
        : increaseButton.classList.remove('disabled');
    }

    if (decreaseButton) {
      this.product.quantity <= 1
        ? decreaseButton.classList.add('disabled')
        : decreaseButton.classList.remove('disabled');
    }
  }

  deleteItem() {
    Metrics.storeTheEvent(
      AppState.planogramName,
      'click',
      MATOMO_EVENT_NAMES.CLICK_SHOPPING_CART_OVERLAY_REMOVE_PRODUCT(this.product?.sku, this.productName)
    );
    this.shoppingCartItems.removeItemFromCart(this.product);
  }

  private countOverallQuantity() {
    this.overallQuantity = this.shoppingCartService.shoppingCart?.products?.reduce((acc, item) => {
      return item.sku === this.product?.sku ? acc + item.quantity : acc;
    }, 0) || 0;
  }
}
